import React from "react";
import ReactPlayer from "react-player";
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

const YouTubeEmbed = ({ url }) => {
const { t } = useTranslation();
  if (!url) return null;

  const isCordova = !!window.cordova;

  // 🔍 Extraction de l'ID
  const videoIdMatch = url.match(/v=([a-zA-Z0-9_-]{11})/);
  const videoId = videoIdMatch ? videoIdMatch[1] : null;
  const thumbnailUrl = videoId
    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    : null;

  const openInYouTube = () => {

    if (window.cordova?.InAppBrowser) {
      window.cordova.InAppBrowser.open(url, "_system");
    } else {
      window.open(url, "_blank");
    }
  };

  if (isCordova) {

    // 📱 Sur mobile : miniature + bouton
    return (
      <div
        className="youtube-preview bg-gray-100 rounded-xl overflow-hidden shadow-md"
        style={{
          width: "100%",
          margin: "10px 0",
        }}
      >
        {thumbnailUrl && (
          <img
            src={thumbnailUrl}
            alt="Miniature YouTube"
            style={{
              display: "block",
              width: "100%",
              height: "auto",
              objectFit: "cover",
            }}
          />
        )}
        <div className="p-3 flex justify-between items-center">
          <span className="text-gray-800 font-medium">🎬 YouTube</span>
          <button
            onClick={openInYouTube}
            className="bouton_youtube bg-red-600 text-white px-3 py-2 rounded-lg text-sm hover:bg-red-700 transition"
          >
            ▶️ {t('discussion.videopreview')}
          </button>
        </div>
      </div>
    );
  }

  // 💻 Web : lecteur intégré
  return (
    <div className="youtube-player my-3 w-full">
      <ReactPlayer url={url} controls width="100%" />
    </div>
  );
};

export default YouTubeEmbed;
